import { useEffect, useRef } from 'react';

export function useInterval(
    callback,
    delay,
    callImmediately = false,
    isReady,
    watchParams
) {
    const savedCallback = useRef();

    // remember the latest callback
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // call immediately if necessary
    useEffect(()=>{
        if (isReady && callImmediately) {
            savedCallback.current();
        }
    }, [isReady, ...watchParams]);

    // set interval
    useEffect(() => {
        if (isReady && delay !== null) {
            let id = setInterval(savedCallback.current, delay);
            return () => clearInterval(id);
        }
    }, [delay, isReady, ...watchParams]);
}
